export const error401 = {
  methods: {
    error401() {
      return this.$router.push('login')
    },
  },
}
